<template>
  <div id="login">
    <h2>扫码核销</h2>
    <div class="login">
      <div class="Sweep"><img :src="imgPath + 'Sweep.jpg'" /></div>
      <a class="loginBtn" @click="scan">扫一扫核销</a>
    </div>

    <div class="content">
      <h3>使用说明：</h3>
      <p>
        用户打开直播间的【个人中心】，进入【我的卡包】页面。点击【立即核销】按钮，核销管理员扫描核销二维码，确认核销信息，即可完成核销。
      </p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import tool from "../../kits/Tools.js";
import { Toast } from "vant";
//保存数据

export default {
  data() {
    return {
      imgPath: "",
    };
  },
  mounted() {
    var that = this;
    this.imgPath = tool.imgPath();
    var username = tool.getCookie("username");
    var password = tool.getCookie("password");
    if (!username || !password) {
      Toast("请登陆后操作。");
      setTimeout(function() {
        that.$router.push({ path: "/login" });
      }, 2000);
      return;
    }
    this.getDynamicData();
  },
  methods: {
    scan() {
      var that = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          window.location.href = result; //因为我这边是扫描后有个链接，然后跳转到该页面
        },
      });
    },
    getDynamicData() {
      var that = this;
      var option = "no_dsid=1";
      this.axios
        .post("https://plive.shikee.tv/fans/share/getWxParams", option)
        .then(function(data) {
          var data = data.data;
          var params = data.data.params;
          if (data.code == 200) {
            wx.config({
              appId: params.appid, // 必填
              timestamp: params.timestamp, // 必填，生成签名的时间戳
              nonceStr: params.noncestr, // 必填，生成签名的随机串
              signature: params.signature, // 必填，签名，见附录1
              jsApiList: ["checkJsApi", "scanQRCode"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            wx.ready(function() {
              wx.checkJsApi({
                jsApiList: ["scanQRCode"],
                success: function(res) {
                  console.log("1111");
                },
              });
            });
          }
        })
        .catch(function(data) {
          console.log("错误" + data);
        });
    },
  },
};
</script>

<style scoped>
.Sweep {
  text-align: center;
}
.Sweep img {
  width: 80%;
}
.loginBtn {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// scan.vue?1591f607